import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(`
      flex flex-col
      items-stretch
      md:grid md:grid-rows-2 md:grid-cols-2
      w-full
      justify-items-center
      md:items-center
      gap-4
      lg:gap-y-40
      md:gap-y-28 md:gap-x-56
      lg:gap-x-96
      md:max-h-menu
      lg:max-h-menuLg
    `)
}
const _hoisted_2 = { class: "md:flex md:content-center md:items-center" }
const _hoisted_3 = { class: "md:flex md:content-center md:items-center" }
const _hoisted_4 = { class: "md:flex md:content-center md:items-center" }
const _hoisted_5 = { class: "md:flex md:content-center md:items-center" }

import { Unlockable } from "@/store";
import Page from "@/utils/pages";
import { useAction } from "@/utils/vuex-hooks";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import PageButton from "../atoms/PageButton.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const unlock = useAction("unlock");

const openPage = (page: Page, unlocked: Unlockable) => {
  router.push({ name: page });
  unlock(unlocked);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(PageButton, {
        icon: "puzzle",
        direction: "left",
        label: _unref(t)('games.header'),
        class: "self-start justify-self-start",
        instrument: "drum",
        onOpen: _cache[0] || (_cache[0] = ($event: any) => (openPage(_unref(Page).Games, _unref(Unlockable).drum)))
      }, null, 8, ["label"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(PageButton, {
        icon: "music",
        direction: "right",
        label: _unref(t)('music.header'),
        class: "self-start justify-self-end",
        instrument: "rhodes",
        onOpen: _cache[1] || (_cache[1] = ($event: any) => (openPage(_unref(Page).Music, _unref(Unlockable).rhodes)))
      }, null, 8, ["label"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(PageButton, {
        icon: "film",
        direction: "left",
        label: _unref(t)('videos.header'),
        class: "self-end justify-self-start",
        instrument: "clarinet",
        onOpen: _cache[2] || (_cache[2] = ($event: any) => (openPage(_unref(Page).Videos, _unref(Unlockable).clarinet)))
      }, null, 8, ["label"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(PageButton, {
        icon: "user",
        direction: "right",
        label: _unref(t)('about.header'),
        class: "self-end justify-self-end",
        instrument: "synth",
        onOpen: _cache[3] || (_cache[3] = ($event: any) => (openPage(_unref(Page).About, _unref(Unlockable).synth)))
      }, null, 8, ["label"])
    ])
  ]))
}
}

})